import React, { useEffect } from "react";

import SearchTemplateHit from "@components/search-template-hits/single-hit";

import { useInstantSearch } from "@stadium/shared/src/components/instant-search";

import styles from "./main.module.scss";

const TrendingTemplates = ({ onTemplateSelect, forBanners, setSearchedHits }) => {
  const { hits } = useInstantSearch();
  const strigifiedHits = JSON.stringify(hits);

  useEffect(() => {
    if (forBanners) setSearchedHits(hits);
    //Keeping hits as dependency will create a new reference for array on each keydown event as hits are live from connectHits thus causing Maximum update depth exceeded.
    //Stringifying it will check for shallow comparision, there is no need for deep comparision in this case as only store_name is being searched upon.

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [strigifiedHits, forBanners]);

  return (
    <div className={styles.searchResultsContentHolder}>
      {hits?.map((hit) => (
        <SearchTemplateHit
          key={hit?.id}
          hit={hit}
          onTemplateSelect={onTemplateSelect}
          forBanners={forBanners}
        />
      ))}
    </div>
  );
};

export default TrendingTemplates;
